module.exports = __webpack_public_path__ + "assets/warning.313ff1d1.svg";